export const CONTACT_COLUMNS = {
  LEFT: "left",
  RIGHT: "right",
};

const normalizePhoneHref = (phone) => {
  const [basePhone] = phone.split(/доб\.?/i);
  const digits = basePhone.replace(/\D/g, "");

  if (!digits) {
    return "";
  }

  return `+${digits}`;
};

const withSectionPhoneHref = (section) => ({
  ...section,
  phoneHref: normalizePhoneHref(section.phone),
});

const CONTACTS_RAW_DATA = [
  {
    id: "tolyatti",
    column: CONTACT_COLUMNS.LEFT,
    sortOrder: 10,
    title: "Тольятти",
    address: "Самарская область, с. Зелёновка, трасса М5 980 километр, 2",
    workingHours: "Ежедневно с 8:00 до 21:00",
    sections: [
      {
        title: "Автосалон",
        phone: "+7 (8482) 43 55 50",
        workingHours: "Ежедневно с 9:00 до 20:00",
        mapHeight: "270px",
        linkAddress: "https://yandex.ru/maps/-/CTCVFS4b",
        location: [53.517944, 49.59073],
      },
      {
        title: "Сервис и запчасти",
        phone: "+7 (8482) 611 550",
        workingHours: "Ежедневно с 8:00 до 21:00",
        mapHeight: "270px",
        linkAddress:
          "https://yandex.ru/maps/?ll=49.591295%2C53.515585&mode=routes&rtext=~53.516339%2C49.592028&rtt=auto&ruri=~ymapsbm1%3A%2F%2Forg%3Foid%3D39413067448&z=16",
        location: [53.516339, 49.592028],
      },
    ],
  },
  {
    id: "kazan",
    column: CONTACT_COLUMNS.LEFT,
    sortOrder: 20,
    title: "Казань",
    address: "Республика Татарстан, Зеленодольский р-н, тер. Придорожная, 16",
    linkAddress:
      "https://yandex.ru/maps/?ll=48.851337%2C55.846138&mode=routes&rtext=~55.846071%2C48.851230&rtt=auto&ruri=~ymapsbm1%3A%2F%2Forg%3Foid%3D73934675765&z=17",
    workingHours: "Ежедневно с 8:00 до 21:00",
    location: [55.846071, 48.85123],
    sections: [
      {
        title: "Продажа автомобилей",
        phone: "+7 (843) 245 60 16",
        workingHours: "Пн - Пт с 9:00 до 18:00",
      },
      {
        title: "Сервис и запчасти",
        phone: "+7 (843) 2390 550",
        workingHours: "Ежедневно с 8:00 до 21:00",
        mapHeight: "270px",
      },
    ],
  },
  {
    id: "ufa",
    column: CONTACT_COLUMNS.LEFT,
    sortOrder: 30,
    title: "Уфа",
    address: "Республика Башкортостан, с. Жуково, ул. Генеральная, 1",
    linkAddress:
      "https://yandex.ru/maps/?ll=55.737046%2C54.662844&mode=routes&rtext=~54.662803%2C55.736787&rtt=auto&ruri=~ymapsbm1%3A%2F%2Forg%3Foid%3D105450808831&z=11",
    workingHours: "Ежедневно с 8:00 до 21:00",
    location: [54.662803, 55.736787],
    sections: [
      {
        title: "Продажа автомобилей",
        phone: "+7 (347) 266 80 02",
        workingHours: "Пн - Пт с 9:00 до 18:00",
      },
      {
        title: "Сервис и запчасти",
        phone: "+7 (347) 262 77 55",
        workingHours: "Ежедневно с 8:00 до 21:00",
        mapHeight: "270px",
      },
    ],
  },
  {
    id: "moscow",
    column: CONTACT_COLUMNS.RIGHT,
    sortOrder: 10,
    title: "Истра",
    address: "Московская область, Истринский район, село Дарна, здание 45/1",
    linkAddress: "https://yandex.ru/maps/-/CPskfBJs",
    phone: "+7 (499) 399 30 09",
    workingHours: "Пн - Пт с 9:00 до 18:00",
    location: [55.929697, 36.946854],
    sections: [
      {
        title: "Автосалон",
        phone: "+7 (499) 399 30 09",
        workingHours: "Пн - Пт с 9:00 до 18:00",
        mapSize: "large",
      },
    ],
  },
  {
    id: "naberezhnye-chelny",
    column: CONTACT_COLUMNS.RIGHT,
    sortOrder: 20,
    title: "Набережные Челны",
    address: "Республика Татарстан, Мензелинский тракт, д. 56",
    linkAddress:
      "https://yandex.ru/maps/236/naberezhnie-chelny/?ll=52.418386%2C55.693953&mode=routes&rtext=~55.693953%2C52.418386&rtt=auto&ruri=~ymapsbm1%3A%2F%2Forg%3Foid%3D90142395796&z=14",
    workingHours: "Ежедневно с 8:00 до 21:00",
    location: [55.693953, 52.418386],
    sections: [
      {
        title: "Продажа автомобилей",
        phone: "+7 (8552) 78 10 16",
        workingHours: "Пн - Пт с 9:00 до 18:00",
      },
      {
        title: "Сервис и запчасти",
        phone: "+7 (8552) 784 550 доб. 1",
        workingHours: "Ежедневно с 8:00 до 21:00",
        mapHeight: "270px",
      },
    ],
  },
  {
    id: "yekaterinburg",
    column: CONTACT_COLUMNS.RIGHT,
    sortOrder: 30,
    title: "Екатеринбург",
    address: "Свердловская обл. г. Березовский, тер. Южная промзона 3",
    linkAddress:
      "https://yandex.ru/maps/29397/berezovskyi/?ll=60.778257%2C56.891417&mode=routes&rtext=~56.891498%2C60.778075&rtt=auto&ruri=~ymapsbm1%3A%2F%2Forg%3Foid%3D166913775108&z=14",
    workingHours: "Ежедневно с 8:00 до 21:00",
    location: [56.891498, 60.778075],
    sections: [
      {
        title: "Продажа автомобилей",
        phone: "+7 (343) 361 10 66",
        workingHours: "Пн - Пт с 9:00 до 18:00",
      },
      {
        title: "Сервис и запчасти",
        phone: "+7 (8482) 622 550",
        workingHours: "Ежедневно с 8:00 до 21:00",
        mapHeight: "270px",
      },
    ],
  },
];

export const CONTACTS_DATA = CONTACTS_RAW_DATA.map((contact) => ({
  ...contact,
  sections: contact.sections.map(withSectionPhoneHref),
}));

const sortByOrder = (a, b) => a.sortOrder - b.sortOrder;

export const CONTACTS_COLUMNS = [
  CONTACT_COLUMNS.LEFT,
  CONTACT_COLUMNS.RIGHT,
].map((column) =>
  CONTACTS_DATA.filter((contact) => contact.column === column).sort(
    sortByOrder,
  ),
);

export const CONTACT_DEFAULTS = {
  WORKING_HOURS: "Ежедневно с 8:00 до 21:00",
  EMAIL: "info@general-trucks.ru",
  COMPANY_NAME: 'ООО "Дженерал Сервис"',
  MAIN_PHONE: "+7 (8482) 43-55-50",
  WEBSITE: "https://general-trucks.com/",
  PERSONAL_INFO: "https://general-trucks.com/personal_information",
  RT: "https://rutube.ru/channel/33901734/",
  VK: "https://vk.com/general_trucks",
  TG: "https://t.me/general_trucks",
};
